import {
  TENANT_BRANDING_APP_TITLE_STORAGE_KEY,
  TENANT_BRANDING_NAME_STORAGE_KEY,
} from "@/constants";

function readStorageValue(key: string): string {
  try {
    return sessionStorage.getItem(key) ?? "";
  } catch {
    return "";
  }
}

/**
 * Set `document.title` from cached branding.
 * Needed on every document load (e.g. authless receipt print tabs): sessionStorage is shared
 * across tabs, but each tab starts with the static `index.html` title until this runs.
 * Browser print-to-PDF uses `document.title` as the default filename.
 */
export function applyStoredDocumentTitle(): void {
  const title =
    readStorageValue(TENANT_BRANDING_APP_TITLE_STORAGE_KEY) ||
    readStorageValue(TENANT_BRANDING_NAME_STORAGE_KEY);
  if (title) {
    document.title = title;
  }
}
